import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { Link, Plus } from 'lucide-react';
import { WorkOrderWithBuilding } from '../../../types/workOrders';
import { sortDelmoment } from '../../../Helpers/projectBoard';
import DelmomentRow from './DelmomentRow';

interface DelmomentListProps {
    workOrders: WorkOrderWithBuilding[];
    today: string;
    getUserName: (uid: string) => string;
    onOpen: (workOrder: WorkOrderWithBuilding) => void;
    onAssign?: (workOrder: WorkOrderWithBuilding) => void;
    onSetDueDate?: (workOrder: WorkOrderWithBuilding) => void;
    /** "+ Nytt delmoment" — omitted when the viewer may not create. */
    onCreate?: () => void;
    /** "Koppla ärende" — omitted when the viewer may not link. */
    onLink?: () => void;
}

/**
 * The flat delmoment list inside an expanded project card, in board order
 * (sortDelmoment), followed by the create / link actions. The card's toggle
 * row is its heading.
 */
const DelmomentList: React.FC<DelmomentListProps> = ({
    workOrders,
    today,
    getUserName,
    onOpen,
    onAssign,
    onSetDueDate,
    onCreate,
    onLink
}) => {
    const sorted = useMemo(() => sortDelmoment(workOrders), [workOrders]);

    return (
        <div className="delmoment-list">
            {sorted.length === 0 ? (
                <div className="delmoment-list__empty">Inga delmoment ännu</div>
            ) : (
                sorted.map(wo => (
                    <DelmomentRow
                        key={wo.key}
                        workOrder={wo}
                        today={today}
                        getUserName={getUserName}
                        onClick={onOpen}
                        onAssign={onAssign}
                        onSetDueDate={onSetDueDate}
                    />
                ))
            )}
            {(onCreate || onLink) && (
                <div className="delmoment-list__footer">
                    {onCreate && (
                        <Button variant="link" size="sm" className="p-0 delmoment-list__footer-btn" onClick={onCreate}>
                            <Plus size={14} />
                            Nytt delmoment
                        </Button>
                    )}
                    {onLink && (
                        <Button variant="link" size="sm" className="p-0 delmoment-list__footer-btn" onClick={onLink}>
                            <Link size={14} />
                            Koppla ärende
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default DelmomentList;
